module.exports = __webpack_public_path__ + "files/9bf9bf5e2777aa02fa61bdb974516840.png";